import { Injectable } from '@angular/core';
import { delay, Observable } from 'rxjs';
import { projectsMockData } from '@mock/data/projects-mock.data';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { IProject } from '@app/api/interfaces/project.interface';
import { IPaginationMeta } from '@app/api/interfaces/common/pagination-meta.interface';
import { MockService } from '@mock/mock.service';
import { OperatingType } from '@app/core/enums/operating-type.enum';
import { MeasurementSystem } from '@app/core/enums/measurement-system.enum';
import { enumToArray } from '@app/shared/utils/enumerator';
import { getRandomDateTime, getRandomInt, getRandomItem } from '@app/shared/utils/random';
import { IListFilter } from '@app/api/interfaces/common/list-filter';
import { LeakDetectionMode } from '@app/core/enums/leak-detection-mode.enum';

@Injectable({
  providedIn: 'root',
})
export class ProjectsMockService extends MockService {
  public readonly projects: IProject[];

  constructor() {
    super();

    this.projects = this.isMockDataGenerated()
      ? this.generateProjects(this.dataGeneratedCount.projects)
      : projectsMockData;
  }

  public getAll(filter: IListFilter): Observable<IApiResponse<IProject[], IPaginationMeta>> {
    return this.mockResponse('PROJECT:getAll', {
      data: this.projects,
      meta: {
        pagination: {
          count: this.projects.length,
          total: this.projects.length,
          offset: 0,
          limit: this.projects.length,
        },
      },
    }).pipe(delay(this.requestDelay));
  }

  public resolveProjectId(index?: number) {
    return index && index > this.projects.length ? this.projects[index].id : this.projects[0].id;
  }

  private generateProjects(count: number): IProject[] {
    return new Array(count).fill(null).map((_, i) => {
      const project: IProject = {
        id: `p_gen_${i}`,
        name: `Project ${i}`,
        operatingType: getRandomItem(enumToArray(OperatingType)),
        loggerCount: getRandomInt(0, 200),
        eventsEnabled: false,
        leakDetectionMode: getRandomItem(enumToArray(LeakDetectionMode)),
      };

      if (getRandomInt(0, 10) > 2) {
        project.lastLoginAt = getRandomDateTime(0, 50).toISOString();
      }

      if (getRandomInt(0, 10) > 2) {
        project.lastMeasurementAt = getRandomDateTime(0, 50).toISOString();
      }

      if (getRandomInt(0, 10) > 2) {
        project.logoUrl = 'imgs/temp-project-logo.png';
      }

      if (getRandomInt(0, 10) > 2) {
        project.viewMeasurementSystem = getRandomItem(enumToArray(MeasurementSystem));
      }

      if (getRandomInt(0, 1)) {
        project.eventsEnabled = true;
      }

      return project;
    });
  }
}
